import { render, staticRenderFns } from "./case-automatic-notification-trigger-grid.vue?vue&type=template&id=4a89b7b8&scoped=true&"
import script from "./case-automatic-notification-trigger-grid.ts?vue&type=script&lang=ts&"
export * from "./case-automatic-notification-trigger-grid.ts?vue&type=script&lang=ts&"
import style0 from "./case-automatic-notification-trigger-grid.scss?vue&type=style&index=0&id=4a89b7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89b7b8",
  null
  
)

export default component.exports